import React, { FC } from 'react';
import { ModuleAdminItemProps } from './types';
import { Box, Icon, IconSize, Text, ToggleSwitch } from '@bechtel/gds';
import { find } from 'lodash';
import { useLingui } from '@lingui/react';

export const ModuleAdminItem: FC<ModuleAdminItemProps> = ({ moduleItem, formikProps, index }) => {
  const { values, setFieldValue } = formikProps;
  const { i18n } = useLingui();
  const valueItem = find(values.modules, (item) => {
    return item.id === moduleItem.id;
  });
  const isActive = valueItem && valueItem.isActive ? valueItem.isActive : false;
  return (
    <Box
      data-testid={`module-item-${index}`}
      justifyContent={{ sm: 'space-between' }}
      alignItems={{ sm: 'center' }}
      py={{ sm: '500' }}
      css={`
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
      `}
    >
      <Box>
        <Box mr={{ sm: '500' }} ml={{ sm: '400' }}>
          <Icon size={IconSize.LARGE} icon={moduleItem.icon} fillColor="bechtel.blue.800" />
        </Box>
        <Box flexDirection={{ sm: 'column' }}>
          <Box mb={{ sm: '300' }}>
            <Text family="graphik" color="grey.1000" size="300">
              {i18n._(moduleItem.name)}
            </Text>
          </Box>
          <Text family="graphik" color="grey.600" size="300">
            {moduleItem.moduleDescription}
          </Text>
        </Box>
      </Box>
      <Box mr={{ sm: '400' }}>
        <ToggleSwitch
          disabled={moduleItem.disabled}
          isToggled={isActive}
          onToggle={() => {
            setFieldValue(`modules[${index}].isActive`, !isActive);
          }}
        />
      </Box>
    </Box>
  );
};
